<template>
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">{{ title }}</h4>
      <span class="close" v-on:click="close"><i class="fa fa-close fa-fw"></i></span>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="filmSearchTitle">{{ _('Search string') }}</label>
            <input type="text" class="form-control" id="filmSearchTitle" v-model="searchStr" />
          </div>
          <button type="button" class="btn btn-success" id="filmSearchButton" v-on:click="search"><i class="fa fa-fw fa-search"></i> {{ _('Search') }}</button>
        </div>
      </div>
      <hr />
      <div class="row">
        <div class="col-md-12" id="filmSearchResults" style="height: 300px; max-height: 300px; overflow-y: auto" v-if="!movie">
          <div class="media well well-sm" v-for="data in results" v-on:click="details(data.id)">
            <div class="media-body">
              <h4 class="media-heading">{{ data.name }}</h4>
              <span>{{ data.year }}</span>
            </div>
          </div>
        </div>
        <div class="col-md-12" id="filmSearchDetails" style="height: 300px; max-height: 300px; overflow-y: auto;" v-if="movie">
          <div class="media well well-sm">
            <div class="media-body" v-if="movie.name">
              <div class="row resultrow" v-for="(value, prop) in movie">
                <div class="col-sm-10" v-if="prop === 'name'">
                  <h4 class="media-heading">{{ value }}</h4>
                </div>
                <div class="col-sm-2" v-if="prop === 'name'"><button class="btn btn-default pull-right closeResultButton" v-on:click="closeResult"><i class="fa fa-fw fa-close"></i></button></div>
                <template v-if="prop !== 'sharedImage'">
                  <div class="col-sm-1"><input type="checkbox" checked="checked" v-model="props" :value="prop"></div>
                  <div class="col-sm-3">{{ prop }}</div>
                  <div class="col-sm-8" v-html="sanitizedValue(value)"></div>
                </template>
              </div>
              <template v-if="movie.sharedImage">
                <div class="row resultrow" v-for="image in movie.sharedImage.filter(image => image.thumbnail_data && ['Stills', 'Posters for web'].includes(image.asset_type_name))">
                  <div class="col-sm-1"><input type="checkbox" checked="checked" v-model="images" :value="'image_' + image.id"></div>
                  <div class="col-sm-11"><img :src="makeImageUrl(image)" :alt="image.title" style="margin-bottom: 10px;" /></div>
                </div>
              </template>
            </div>
            <div class="media-body" v-else>
              {{ _('Processing, please wait...') }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-default hidden-xs" v-on:click="close"><i class="fa fa-close fa-fw"></i> {{ _('Close') }}</button>
      <button type="button" class="btn btn-success" v-on:click="select" :disabled="!isValid"><i class="fa fa-check fa-fw"></i>{{ _('Ok') }}</button>
    </div>      
  </div>
</template>

<script>
import axios from 'axios'
import DOMPurify from 'dompurify'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      searchStr: '',
      results: [],
      movie: null,
      props: [],
      images: []
    }
  },
  props: ['service', 'title', 'origSearch'],
  computed: {
    ...mapGetters(['baseDomain', 'locale']),
    shortLocale () {
      return this.locale.split('_')[0]
    },
    isValid () {
      return !!this.movie && this.props && this.props.length
    }
  },
  methods: {
    sanitizedValue(value) {
      return DOMPurify.sanitize(value, {
        ALLOWED_TAGS: ['br', 'p', 'strong', 'em', 'i', 'b'],
        ALLOWED_ATTR: [] // No attributes allowed
      })
    },
    makeImageUrl(image) {
      return 'data:image/jpeg;base64,' + image.thumbnail_data
    },
    async search () {
      let response
      this.results = []
      this.movie = null
      try {
        response = await axios.get(this.baseDomain + 'api/filmsearch/index.php?action=search&service=' + this.service + '&search=' + encodeURIComponent(this.searchStr))
      } catch (e) {
        return
      }
      this.results = response.data
    },
    async details (id) {
      this.movie = {}
      let response
      try {
        response = await axios.get(this.baseDomain + 'api/filmsearch/index.php?action=details&service=' + this.service + '&search=' + id)
      } catch (e) {
        return
      }
      // Strip out values that are 0, empty or empty arrays
      Object.keys(response.data).forEach(key => (response.data[key] === '0' || !response.data[key] || (response.data[key].constructor === Array && !response.data[key].length)) ? delete response.data[key] : {})
      this.props = Object.keys(response.data).filter(key => key !== 'material_notes')
      if(response.data.sharedImage && Array.isArray(response.data.sharedImage)) {
        // Apply the same filter as in the template
        this.images = response.data.sharedImage
          .filter(image => image.thumbnail_data && ['Stills', 'Posters for web'].includes(image.asset_type_name))
          .map(image => 'image_' + image.id)
      } else {
        this.images = []
      }
      this.movie = response.data
    },
    closeResult() {
      this.movie = null
    },
    close () {
      this.$emit('close')
    },
    select () {
      const ret = {}
      for (let i = 0; i < this.props.length; i++) {
        if(this.props[i] === 'sharedImage') {
          continue
        }
        const p = this.props[i]
        ret[p] = this.movie[p]
      }
      ret.images = []
      for (let i = 0; i < this.images.length; i++) {
        const id = this.images[i]
        const image = this.movie.sharedImage.find(image => image.id === id.replace('image_', ''))
        if(image) {
          ret.images.push(image)
        }
      }
      this.$emit('selectMovie', ret)
    }
  },
  created() {
    if (this.origSearch) {
      this.searchStr = this.origSearch
    }
  },
  mounted() {
    if (this.searchStr) {
      this.search()
    }
  }
}  

</script>